"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissButton = exports.container = void 0;

var _react = require("@emotion/react");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    background-color: transparent;\n  }\n  padding: 0;\n  margin: 0;\n  height: 44px;\n  width: 44px;\n  position: absolute;\n  right: -8px;\n  top: -8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var container = function container(dismissable) {
  return function (_ref) {
    var colors = _ref.colors;
    return (0, _react.css)(_templateObject(), dismissable ? '21px 24px 21px 16px' : '16px', colors.neutral[50], colors.neutral[100]);
  };
}; // Why height/width is 44px when icon size is 12px: https://www.w3.org/WAI/WCAG21/Understanding/target-size.html


exports.container = container;
var dismissButton = (0, _react.css)(_templateObject2());
exports.dismissButton = dismissButton;